import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#007C66',
    contrastText: '#3366cc',
    dark: '#1C614C'
  },
  secondary: {
    main: '#4D60C9',
    dark: '#1A2B82'
  },
  error: {
    main: '#E30000',
    light: '#ffe8e3'
  },
  text: {
    primary: '#1E233E',
    secondary: '#007AFF'
  },
  grey: {
    50: '#e3e3e3',
    100: '#f3f3f3',
    200: '#676A7B',
    300: '#F8F8F8'
  },
  common: {
    white: '#fff'
  },
  warning: {
    main: '#D5792C',
    dark: '#781E0E',
    light: '#FFC2B5'
  },
  divider: '#E3E3E3'
};
